import { createElement, styled, compose, position, flexbox, layout, typography, color, space, textDecoration, textOverflow, outline, lineHeight, userSelect, minHeight, borderBottom, flexDirection, alignItems, flexGrow } from '@vebox/etui-system';

const AElement = createElement('a');
const A = styled(AElement)(compose(position, flexbox, layout, typography, color, space, textDecoration, textOverflow, outline, lineHeight, userSelect, minHeight, borderBottom, flexDirection, alignItems, flexGrow));
A.displayName = 'A';

export { A };
